import Mutations from './mutations-types'

export default {
  [Mutations.SET_USER_SESSIONS](state, payload) {
    state.userSessions = [...payload]
  },

  [Mutations.NEW_USER_SESSION](state, newSession) {
    state.userSessions.unshift(newSession)
  },

  [Mutations.ADD_USER_SESSION](state, payload) {
    state.userSessions = [...state.userSessions, ...payload]
  },

  [Mutations.REMOVE_USER_SESSION](state, payload) {
    const index = state.userSessions.findIndex((session) => session.id === payload.id)

    if (index !== -1) {
      state.userSessions.splice(index, 1)
    }
  },

  [Mutations.UPDATE_USER_SESSION](state, payload) {
    const index = state.userSessions.findIndex((session) => session.id === payload.id)

    if (index !== -1) {
      state.userSessions.splice(index, 1, payload)
    }
  }
}